
export const environment = {
  project: 'prezzemolo-test',
  production: false,
  project_name: 'Prezzemolo Test',
  assets_path: 'prezzemolo-e-vitale',
  api: 'https://api.dev.prezzemolo.soluzionitop.com/api/admin/',
  max_file_size_kb: 51200,
  logo_bg_color: '#ffffff'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
